module.exports = __webpack_public_path__ + "img/anggota_out.eb669cdf.png";